<template>
  <b-container class="countdown-cnt">
    <!-- Days -->
    <div class="countdown-card">
      <h2 class="countdown-title">{{ countdownDays | two_digits }}</h2>
      <p class="countdown-subtitle">Days</p>
    </div>
    <!-- Hours -->
    <div class="countdown-card">
      <h2 class="countdown-title">{{ countdownHours | two_digits }}</h2>
      <p class="countdown-subtitle">Hours</p>
    </div>
    <!-- Minutes -->
    <div class="countdown-card">
      <h2 class="countdown-title">{{ countdownMins | two_digits }}</h2>
      <p class="countdown-subtitle">Minutes</p>
    </div>
    <!-- Seconds -->
    <div class="countdown-card">
      <h2 class="countdown-title">{{ countdownSecs | two_digits }}</h2>
      <p class="countdown-subtitle">Seconds</p>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "Countdown",
  props: {
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      countdownProgress: 0,
      countdownDays: 0,
      countdownHours: 0,
      countdownMins: 0,
      countdownSecs: 0,
    };
  },
  methods: {
    countdownInit() {
      var timer;
      var now = new Date();
      var timeDiff = new Date(this.endDate).getTime() - now.getTime();
      var seconds = Math.floor(timeDiff / 1000);
      var minutes = Math.floor(seconds / 60);
      var hours = Math.floor(minutes / 60);
      var days = Math.floor(hours / 24);
      hours %= 24;
      minutes %= 60;
      seconds %= 60;
      if (days < 0) {
        days = hours = minutes = seconds = 0;
      }

      this.countdownDays = days;
      this.countdownHours = hours;
      this.countdownMins = minutes;
      this.countdownSecs = seconds;
      if (timeDiff <= 0) {
        clearTimeout(timer);
        return;
      }
      timer = setTimeout(this.countdownInit, 1000);
    },
    getTimeRemainingFromDate() {
      const deadline = "December 31 2021 23:59:59 GMT-0700";
      const timeLeft = this.getTimeRemaining(deadline);
      this.days = timeLeft.days;
      this.hours = timeLeft.hours;
      this.minutes = timeLeft.minutes;
      this.secs = timeLeft.seconds;
    },
  },
  filters: {
    two_digits(value) {
      if (value.toString().length <= 1) {
        return "0" + value.toString();
      }
      return value.toString();
    },
  },
  mounted() {
    this.countdownInit();
  },
};
</script>

<style lang="scss" scoped>
.countdown-cnt {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 128px;
  max-width: 620px;
  z-index: 2;
  .countdown-card {
    height: 200px;
    width: 100%;
    border-radius: 4px;
    background: linear-gradient(0deg, #ededed 0%, #ffffff 52.9%, #ededed 100%);
    box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .countdown-title {
      color: $red;
      font-family: Gotham;
      font-size: 66px;
      font-weight: 900;
      letter-spacing: 0;
      line-height: 73px;
      text-align: center;
      text-shadow: 0 0 10px 0 rgba(151, 35, 63, 0.12);
      margin: 0;
    }
    .countdown-subtitle {
      color: $grey;
      font-family: Gotham;
      font-size: 12px;
      font-weight: 900;
      letter-spacing: 2px;
      line-height: 24px;
      text-align: center;
      text-transform: uppercase;
      margin: 0;
    }
  }
}
@media only screen and (max-width: $sm) {
  .countdown-cnt {
    flex-wrap: wrap;
    margin: 190px auto 0;
    padding: 0;
    .countdown-card {
      flex-basis: calc(50% - 10px);
    }
  }
}
</style>
